// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"511":"8d1ec839","763":"1d2e5c8b"}[chunkId] + ".chunk.css";
};